import { Observable, ReplaySubject, Subject } from 'rxjs/Rx'

type ILazyObservableSeed<T> = () => Observable<T>
type ILazyObservableSeedFunction<T> = () => T

export class ObservableUtils {

  public lazyObservable<T>(seedObservableFn: ILazyObservableSeed<T>|ILazyObservableSeedFunction<T>): Observable<T> {
    return Observable.of('').concatMap(() => {
      const value = seedObservableFn()
      return (this.isObservable(value) ? value : Observable.of(value)) as Observable<T>
    })
  }

  public memoizedLazyObservable<T>(decoratedObservable: Observable<T>): Observable<T> {
    let relayedSubject: ReplaySubject<T>

    const memoizedObservableCreator = () => {
      if (relayedSubject) { return relayedSubject }
      relayedSubject = new ReplaySubject<T>()

      return decoratedObservable.do(
        (result) => { relayedSubject.next(result) },
        (error) => { relayedSubject.error(error) },
        () => { relayedSubject.complete() }
      )
    }
    return this.lazyObservable(memoizedObservableCreator)
  }

  public isObservable(value: any) {
    // Because `Observable` is provided by rxjs and rxjs/Rx (at least),
    // instance of may not work as expected and therefore the Type name is checked here.
    // Alternatively we try duck typing or ensure we only use one rxjs package for imports
    return value instanceof Observable || value instanceof Subject
       || (value && value.constructor && (
            value.constructor.name === 'Observable'
         || value.constructor.name === 'Subject'
         || value.constructor.name === 'ReplaySubject')
       )
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/observable-utils/observable-utils.ts